<template>
  <div>
    <b-card
      no-body
    >
      <div class="m-2">
        <b-row
          align-v="center"
        >
          <b-col cols="12">
            <b-form-group
              :label="$t('Period')"
              label-for="period"
            >
              <v-select
                id="period"
                v-model="quoteDistribution.period"
                :reduce="(option) => option.id"
                :options="periods"
                :get-option-label="(option) => option.admission_year + '-' + option.name"
                @input="loadQuotes"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="quoteDistribution.period">
          <b-col
            v-if="loading"
            class="text-center"
          >
            <b-spinner
              variant="primary"
            />
          </b-col>
          <b-col
            v-else
          >
            <div v-if="Array.isArray(financeAcceptedLetterQuote)">
              <h4 class="text-center">
                {{ $t('Requested quota for {year}', { year: getPeriod(quoteDistribution.period).admission_year }) }}
              </h4>
              <div>
                <b-table
                  ref="refFinanceAcceptedLetterQuoteTable"
                  :items="financeAcceptedLetterQuote"
                  responsive
                  :fields="tableColumns"
                  primary-key="id"
                  show-empty
                  :empty-text="$t('No matching records found')"
                  class="position-relative table-bordered"
                >
                  <template #head()="data">
                    {{ getHead(data) }}
                  </template>

                  <template #cell(type_org_id)="data">
                    {{ $langName(getOrgType(data.value).name) }}
                  </template>

                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner
                        variant="primary"
                        label="Text Centered"
                      />
                    </div>
                  </template>
                </b-table>
                <div>
                  <hr>
                  <h4 class="text-center">
                    {{ $t('Formation of quota for {year}', { year: getPeriod(quoteDistribution.period).admission_year }) }}
                  </h4>
                  <b-form
                    @submit.prevent
                  >
                    <validation-observer ref="totalQuoteValidation">
                      <b-row>
                        <b-col
                          md="12"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('Organization')"
                            rules="required"
                          >
                            <b-form-group
                              :label="$t('Organization')"
                              label-for="to_org"
                            >
                              <v-select
                                id="to_org"
                                v-model="to_org"
                                :reduce="(option) => option.id"
                                :options="organizations"
                                :get-option-label="(option) => $langName(option.name)"
                              />
                            </b-form-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col
                          md="12"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('Description')"
                            rules="required"
                          >
                            <!-- Dc amount -->
                            <b-form-group
                              :label="$t('Description')"
                              label-for="about"
                            >
                              <b-form-textarea
                                id="about"
                                v-model="quoteDistribution.about"
                              />
                            </b-form-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col
                          md="12"
                        >
                          <b-form-group
                            :label="$t('File')"
                            label-for="file"
                          >
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('File')"
                              rules="required|file-size:10"
                            >
                              <b-form-file
                                v-model="quoteDistribution.file"
                                :placeholder="$t('Choose a file or drop it here...')"
                                accept="application/pdf"
                                :drop-placeholder="$t('Drop file here...')"
                                :state="errors.length > 0 ? false:null"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <fieldset-component
                        v-for="quoteOrgType in [itemOTM, itemITM, itemCommon]"
                        :key="quoteOrgType[0].org_type"
                        :title="$langName(getQuoteOrgType(quoteOrgType[0].org_type).name)"
                      >
                        <b-row>
                          <b-col
                            v-for="item in quoteOrgType"
                            :key="item.org_type + '_' + item.dc_type"
                            :md="quoteOrgType.length > 1 ? 6 : 12"
                          >
                            <validation-provider
                              #default="{ errors }"
                              :name="$langName(getDcType(item.dc_type).name)"
                              rules="required|integer"
                            >
                              <!-- Dc amount -->
                              <b-form-group
                                :label="$langName(getDcType(item.dc_type).name)"
                                :label-for="item.org_type + '_' + item.dc_type"
                              >
                                <b-form-input
                                  :id="item.org_type + '_' + item.dc_type"
                                  v-model="item.amount"
                                  trim
                                />
                              </b-form-group>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-col>
                        </b-row>
                      </fieldset-component>
                      <div class="d-flex mt-2">
                        <b-button
                          variant="primary"
                          class="mr-2"
                          type="submit"
                          @click="submit"
                        >
                          {{ $t('Distribution') }}
                        </b-button>
                      </div>
                    </validation-observer>
                  </b-form>
                </div>
              </div>
            </div>
            <div v-else>
              {{ $t('It is not possible to create a quota for {year}', { year: getPeriod(quoteDistribution.period).admission_year }) }}
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>

import {
  BCard, BRow, BCol, BFormGroup, VBToggle, BSpinner, BTable,
  BForm, BFormInput, BFormTextarea, BFormFile, BButton,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import store from '@/store'
import quoteDistributionModule from '@/store/quote-distribution'
import periodModule from '@/store/period'
import organizationModule from '@/store/organization'
import { required, integer } from '@/libs/validations/validations'
import fieldsetComponent from '@/views/components/FieldsetComponent.vue'

export default {
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
    BSpinner,
    BTable,
    BFormInput,
    BFormTextarea,
    BFormFile,
    BButton,
    ValidationProvider,
    ValidationObserver,
    fieldsetComponent,
  },
  data() {
    return {
      loading: true,
      required,
      integer,
      to_org: null,
      itemOTM: [
        {
          to_org: null,
          org_type: this.quoteOrgTypeOTM,
          dc_type: this.DSc,
          amount: 0,
        },
        {
          to_org: null,
          org_type: this.quoteOrgTypeOTM,
          dc_type: this.PhD,
          amount: 0,
        },
      ],
      itemITM: [
        {
          to_org: null,
          org_type: this.quoteOrgTypeITM,
          dc_type: this.DSc,
          amount: 0,
        },
        {
          to_org: null,
          org_type: this.quoteOrgTypeITM,
          dc_type: this.PhD,
          amount: 0,
        },
      ],
      itemCommon: [
        {
          to_org: null,
          org_type: this.quoteOrgTypeCommon,
          dc_type: this.traineeResearcher,
          amount: 0,
        },
      ],
    }
  },
  computed: {
    quoteDistribution() {
      return this.$store.state.quoteDistribution.quoteDistribution
    },
    periods() {
      return this.$store.state.period.periods
    },
    financeAcceptedLetterQuote() {
      return this.$store.state.quoteDistribution.financeAcceptedLetterQuote
    },
    getDcTypes() {
      return this.$store.getters['staticModule/getSimpleDcTypes']
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
  },
  created() {
    localize(this.$i18n.locale)
    const dcTypes = this.getDcTypes
    dcTypes.forEach(dcType => {
      this.tableColumns.push({
        key: `${dcType.id}`,
      })
    })
    this.tableColumns.push({
      key: 'total',
    })
    this.$store.commit(`${this.MODULE_NAME}/FRESH`, { total_quote_type: this.totalQuoteTypeGive })
    this.$store.dispatch('period/list', { status: 'True', step: this.$store.state.staticModule.stepFinancialQuoteDistribution })
    this.$store.dispatch('organization/list', { type_org_id: this.orgTypeInnovation })
  },
  methods: {
    loadQuotes() {
      if (this.quoteDistribution.period) {
        this.loading = true
        this.$store.dispatch(`${this.MODULE_NAME}/financeAcceptedLetterQuote`, { period: this.quoteDistribution.period }).catch(err => {
          this.$errorSwal(this, err)
        }).finally(() => {
          this.loading = false
        })
      }
    },
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    getPeriod(id) {
      return this.$store.getters[`${this.MODULE_PERIOD}/getPeriod`](id)
    },
    getQuoteOrgType(id) {
      return this.$store.getters['staticModule/getQuoteOrgType'](id)
    },
    getHead(head) {
      const col = head.column
      if (Number(col) >= 100 && Number(col) <= 700) {
        return this.$langName(this.getDcType(Number(col)).name)
      }
      return this.$t(head.label)
    },
    getOrgType(type) {
      return this.$store.getters['staticModule/getOrgType'](type)
    },
    submit() {
      this.$refs.totalQuoteValidation.validate().then(success => {
        if (success) {
          this.quoteDistribution.total_quote_items = [...this.itemITM, ...this.itemOTM, ...this.itemCommon]
          this.quoteDistribution.total_quote_items.forEach(item => {
            // eslint-disable-next-line no-param-reassign
            item.to_org = this.to_org
          })
          this.$confirmCode({
            callback: (confirm, code) => {
              if (confirm) {
                this.$createSwal(this, { ...this.quoteDistribution, code }, `${this.MODULE_NAME}/createQuoteDistribution`, () => {
                  this.$router.push({ name: 'quote-distribution' })
                })
              }
            },
          })
        }
      })
    },
  },
  setup() {
    const tableColumns = [
      { key: 'type_org_id', label: 'Type Org', sortable: true },
    ]
    const {
      quoteOrgTypeITM, quoteOrgTypeOTM, quoteOrgTypeCommon,
      DSc, PhD, traineeResearcher, totalQuoteTypeGive, orgTypeInnovation,
    } = store.state.staticModule
    const MODULE_NAME = 'quoteDistribution'
    const MODULE_PERIOD = 'period'
    const MODULE_ORGANIZATION = 'organization'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, quoteDistributionModule)
    if (!store.hasModule(MODULE_PERIOD)) store.registerModule(MODULE_PERIOD, periodModule)
    if (!store.hasModule(MODULE_ORGANIZATION)) store.registerModule(MODULE_ORGANIZATION, organizationModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
      if (store.hasModule(MODULE_PERIOD)) store.unregisterModule(MODULE_PERIOD)
      if (store.hasModule(MODULE_ORGANIZATION)) store.unregisterModule(MODULE_ORGANIZATION)
    })
    return {
      MODULE_NAME,
      MODULE_PERIOD,
      MODULE_ORGANIZATION,
      tableColumns,
      quoteOrgTypeOTM,
      quoteOrgTypeITM,
      quoteOrgTypeCommon,
      DSc,
      PhD,
      traineeResearcher,
      totalQuoteTypeGive,
      orgTypeInnovation,
    }
  },
}
</script>
